module.exports = __webpack_public_path__ + "static/media/gabriel_2.e4477651.jpg";